export enum ProgressStatuses {
    Started,
    Invited,
    Proposed,
    Declined,
    Hired,
    Finished,
    Closed
}